import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as AlbumViewStyles from "../styles/albumView";

//COMPONENTS
import ImageSlot from "./imageSlot";

function AlbumView() {
    const dispatch = useDispatch();
    const params = useParams();
    const [uploadFiles, setUploadFiles] = useState(null);
    const [images, setImages] = useState([]);

    const [modal, setModal] = useState({
        header: "",
        open: false,
        message: "",
        error: false
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const [failedFilesModal, setFailedFilesModal] = useState({
        files: [],
        open: false
    });

    function handleCloseFailedFilesModal() {
        setFailedFilesModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle(`Photo Gallery - ${params.name}`));
        dispatch(GS_navSettingsActions.UpdateSelected("Media"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Photo Gallery"));

        loadPhotos();
    }, []);

    function loadPhotos() {
        const data = { album: params.name };
        Axios.post("/pods/CPOD_PHOTOGALLERY_ADMIN/findAlbumPhotos", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setImages(data.files);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleInputChange(e) {
        setUploadFiles(e.target.files);
    }

    function handleUploadClick(e) {
        e.preventDefault();
        let localFiles = [];

        for (const [key, file] of Object.entries(uploadFiles)) {
            localFiles.push({
                id: key,
                name: file.name,
                size: file.size,
                type: file.type
            });
        }

        const checkData = {
            files: localFiles,
            album: params.name
        };

        const uploadImageData = new FormData();
        uploadImageData.append("album", params.name);

        const uploadConfig = {
            headers: {
                "content-type": "multiple/form-data"
            }
        };

        Axios.post("/pods/CPOD_PHOTOGALLERY_ADMIN/checkFiles", checkData)
            .then((res) => {
                const firstData = res.data;
                if (firstData.limitError == "Yes") {
                    setModal({
                        error: true,
                        header: "File Limit Error",
                        message: "You can only upload 5 files at a time!",
                        open: true
                    });
                } else {
                    localFiles.forEach((lFile) => {
                        const file = firstData.files.find((file) => file.id === lFile.id);
                        if (file == null) {
                            uploadImageData.append("photos", uploadFiles[lFile.id]);
                        }
                    });
                    Axios.post("/pods/CPOD_PHOTOGALLERY_ADMIN/uploadImages", uploadImageData, uploadConfig)
                        .then((res) => {
                            const secondData = res.data;
                            if (secondData.name === "MulterError") {
                                setModal({
                                    error: true,
                                    header: "File Upload: Error",
                                    message: secondData.message,
                                    open: true
                                });
                            } else if (firstData.failed) {
                                setFailedFilesModal({ files: firstData.files, open: true });
                            } else {
                                loadPhotos();
                                setUploadFiles(null);
                                setModal({
                                    error: false,
                                    header: "File Upload: Success!",
                                    message: secondData.message,
                                    open: true
                                });
                            }
                        })
                        .catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={AlbumViewStyles.body}>
            <Row>
                <Col>
                    <h3>Upload:</h3>
                    <div style={AlbumViewStyles.uploadView}>
                        <Form.Control type="file" name="photo" onChange={handleInputChange} multiple />
                        <Button onClick={handleUploadClick}>Upload</Button>
                    </div>
                    <p>
                        <strong>max. 5 files, image format only, max 8MB per file</strong>
                    </p>
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                {images.map((image, index) => {
                    return (
                        <Col md="auto" style={AlbumViewStyles.columnPadding} key={index}>
                            <ImageSlot name={image} album={params.name} />
                        </Col>
                    );
                })}
            </Row>

            {/* MODALS */}
            <Modal show={modal.open} onHide={handleCloseModal}>
                <Modal.Header closeButton style={modal.error ? AlbumViewStyles.errorModalColor : AlbumViewStyles.successModalColor}>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal size="lg" show={failedFilesModal.open} onHide={handleCloseFailedFilesModal}>
                <Modal.Header closeButton style={AlbumViewStyles.filesTableheading}>
                    <Modal.Title>Upload: Failed Files</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        The following files could not be uploaded as to the reasons given
                        <br />
                        <table border="1px" width="100%">
                            <thead>
                                <tr>
                                    <th>File</th>
                                    <th>Reason</th>
                                </tr>
                            </thead>
                            <tbody>
                                {failedFilesModal.files.map((file, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={AlbumViewStyles.filesTableRow}>{file.file}</td>
                                            <td style={AlbumViewStyles.filesTableRow}>{file.message}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <br />
                        <strong>Spaces in file names will be replaced by a &#39;_&#39; (underscore)</strong>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseFailedFilesModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default AlbumView;
